import { useQuery } from "@tanstack/react-query";
import { StoresAPI } from "../api";

let user = JSON.parse(localStorage.getItem("user"))

const fetchData = () => {
    return StoresAPI.get({ params: { sellerId: user?.id || 1 } });
};
export const useFetchStores = () => {
    return useQuery({
        queryKey: ["stores"],
        queryFn: fetchData,
        refetchOnWindowFocus: false, // Disable refetching on window focus
    });
};
